import { PlusOutlined } from "@ant-design/icons";
import {
  Col,
  Form,
  Row,
  Select,
  Switch,
  Card,
  Divider,
  Button,
  Spin,
} from "antd";
import { useEffect, useState } from "react";
import { httpService } from "../../../../../services/httpService.service";
import AddTeamCardModal from "../../../implementation/FieldLogisticsBoard/modals/AddTeamCardModal";
import MessagePopUp from "../../../../components/Messages/MessagePopUp";

const { Option } = Select;

const TeamDetails = ({ singleTeam, setSingleTeam }) => {
  const [teams, setTeams] = useState([]);
  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });
  const [showAddTeamCardModal, setShowAddTeamCardModal] = useState(false);
  const [singleTeamLoader, setSingleTeamLoader] = useState(false);

  const [teamLoading, setTeamLoading] = useState(false);

  const getAllTeams = () => {
    const contractId = localStorage.getItem("currentContractId");
    const apiTeams = `/api/User/getAllTeams?contractId=${contractId}`;
    setTeamLoading(true);

    httpService.get(
      apiTeams,
      (res) => {
        setTeams(res.data?.filter((e) => e?.isActive === true));
        setTeamLoading(false);
      },
      (error) => {
        setTeamLoading(false);
      }
    );
  };

  useEffect(() => {
    getAllTeams();
  }, []);

  const selectTeam = (teamID) => {
    setSingleTeamLoader(true);
    httpService.get(
      `/api/User/getTeamById?teamId=${teamID}`,
      (res) => {
        setSingleTeam(res?.data);
        setSingleTeamLoader(false);
      },
      (err) => {
        // console.log(err);
        setSingleTeamLoader(false);
      }
    );
  };

  return (
    <div>
      <MessagePopUp
        trigger={message.trigger}
        type={message.type}
        icon={message.icon}
        messageTitle={message.title}
        messageText={message.text}
      />
      <div className="tripLogisticsCard container mb-4">
        <div className="tripLogicWrapper row align-items-center justify-content-center text-center text-md-start text-lg-start ">
          <div className="col-12 col-lg-8">
            <h4>
              If you don't see your team on the list,
              <br className="d-block d-lg-block d-md-none" />
              create a new one!
            </h4>
          </div>

          <div className="col-12 col-lg-4 d-flex justify-content-center justify-content-lg-end">
            <Button
              icon={<PlusOutlined />}
              onClick={() => setShowAddTeamCardModal(true)}
              iconPosition="end"
              className="inviteButtonTPM w-100 w-lg-auto"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Create team card
            </Button>
          </div>
        </div>
      </div>

      {/* {teamCardVisible ? ( */}
      {/* <div className="teamAdd"> */}
      <AddTeamCardModal
        visible={showAddTeamCardModal}
        onClose={() => setShowAddTeamCardModal(false)}
        fetchTeams={getAllTeams}
        setMessage={setMessage}
      />
      {/* </div> */}
      {/* ) : (
        <></>
      )} */}
      <Spin spinning={teamLoading}>
        <div className="container">
          <div className="row align-items-center">
            <Form.Item
              label={
                <span className="text-nowrap">
                  Select a Team Name for Data Collection
                </span>
              }
              name="team"
              rules={[{ required: true }]}
              className="col-12 col-lg-6"
            >
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) ===
                  0
                }
                placeholder="Select a team"
                onChange={(team) => selectTeam(team)}
              >
                {teams &&
                  teams.map((team) => (
                    <Option key={team?.id} value={team?.id}>
                      {team?.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="isTeamLocal"
              style={{ marginBottom: 0 }}
              className="col-12 col-lg-6"
              valuePropName="checked"
              label="Team is Local"
              layout="horizontal"
            >
              <Switch />
            </Form.Item>
          </div>
        </div>
      </Spin>

      {singleTeamLoader ? (
        <Spin style={{ width: "100%" }} />
      ) : singleTeam?.members?.length > 0 ? (
        <div className="teamDetails">
          <Card title="Team Details" className="teamDetailsCard">
            {singleTeam?.members
              ?.filter((el) => el?.roleName === "Field Team Leader")
              ?.map((user, index) => (
                <div key={index}>
                  <h1 style={{ fontSize: "16px", margin: "0" }}>
                    {user?.firstName && user?.lastName
                      ? `${user?.firstName} ${user?.lastName}`
                      : user?.username}
                  </h1>
                  <p style={{ fontSize: "12px", margin: "0", color: "gray" }}>
                    Team Leader
                  </p>
                </div>
              ))}
            <Divider />
            {singleTeam?.members
              ?.filter((el) => el?.roleName === "Field Coordinator")
              ?.map((user, index) => (
                <div key={index}>
                  <h1 style={{ fontSize: "16px", margin: "0" }}>
                    {user?.firstName && user?.lastName
                      ? `${user?.firstName} ${user?.lastName}`
                      : user?.username}
                  </h1>
                  <p style={{ fontSize: "12px", margin: "0", color: "gray" }}>
                    Field Coordinator
                  </p>
                </div>
              ))}
            {singleTeam?.drivers?.length > 0 && (
              <div>
                <h1 style={{ fontSize: "16px", margin: "0" }}>
                  {singleTeam?.drivers[0]?.name}
                </h1>
                <p style={{ fontSize: "12px", margin: "0", color: "gray" }}>
                  Driver
                </p>
              </div>
            )}
            <Divider />
            {singleTeam?.members
              ?.filter((el) => el?.roleName === "Field Enumerator")
              ?.map((user, index) => (
                <div key={index}>
                  <h1 style={{ fontSize: "16px", margin: "0" }}>
                    {user?.firstName && user?.lastName
                      ? `${user?.firstName} ${user?.lastName}`
                      : user?.username}
                  </h1>
                  <p style={{ fontSize: "12px", margin: "0", color: "gray" }}>
                    Enumerator
                  </p>
                </div>
              ))}
          </Card>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
export default TeamDetails;
